
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ref, computed, onMounted } from 'vue';
gsap.registerPlugin(ScrollTrigger);

export default {
  setup() {
    const debug = ref(false);
    const debugEmail = ref('');
    const name = ref('');
    const email = ref('');
    const company = ref('');
    const subject = ref('');
    const description = ref('');
    const type = ref('');
    const errors = ref<string[]>([]);

    const recaptchaKey = '6Lf-lDIrAAAAAPIk0cItyWhqhIyHVAm4ccpdMncS';
    const captchaSettings = computed(() => JSON.stringify({
      keyname: 'Test2',
      fallback: 'true',
      orgId: '00DUB000004gHDR',
      ts: Date.now().toString()
    }));

    const inputClass = (field: string) => [
      'w-full border rounded px-3 py-2',
      hasError(field) ? 'border-red-500' : 'border-gray-300'
    ];

    const hasError = (field: string) => errors.value.some(error => error.toLowerCase().includes(field.toLowerCase()));

    const handleSubmit = () => {
      errors.value = [];

      if (!name.value) errors.value.push('Name is required');
      if (!email.value) errors.value.push('Email is required');
      if (!subject.value) errors.value.push('Subject is required');
      if (!description.value) errors.value.push('Description is required');
      if (!type.value) errors.value.push('Topic is required');

      const response = (document.getElementById('g-recaptcha-response') as HTMLInputElement)?.value;
      if (!response || response.trim() === '') {
        errors.value.push('Please complete the reCAPTCHA.');
      }

      if (errors.value.length === 0) {
        const form = document.querySelector('form') as HTMLFormElement;
        form.submit();
      }
    };

    onMounted(() => {

        const params = new URLSearchParams(window.location.search);
        debug.value = params.get('debug') === '1';
        debugEmail.value = params.get('debugEmail') || params.get('debugmail') || '';


        // Add reCAPTCHA script dynamically
        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js';
        script.async = true;
        script.defer = true;
        script.id = 'recaptcha-script';

        // Only inject if not already present
        if (!document.getElementById('recaptcha-script')) {
            document.head.appendChild(script);
        }

      document.body.classList.add('dark-header');

      const elements = document.querySelectorAll('.ani-top');
      gsap.set(elements, { opacity: 0, y: -50 });
      gsap.to(elements, {
        y: 0,
        opacity: 1,
        duration: 0.5,
        ease: 'slow',
        stagger: 0.2
      });

      setInterval(() => {
        const response = document.getElementById('g-recaptcha-response') as HTMLInputElement;
        const field = document.getElementsByName('captcha_settings')[0] as HTMLInputElement;

        if (response && field && response.value.trim() === '') {
          const obj = JSON.parse(field.value);
          obj.ts = Date.now().toString();
          field.value = JSON.stringify(obj);
        }
      }, 500);
    });

    return {
        debug,
        debugEmail,
        name,
        email,
        company,
        subject,
        description,
        type,
        errors,
        captchaSettings,
        recaptchaKey,
        handleSubmit,
        hasError,
        inputClass
    };
  },
  unmounted() {
    ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  }
};
